// extracted by mini-css-extract-plugin
module.exports = {"animationA":"animationA_animationA__O_4gE"};